export const PatientLookupActions = {
    SHOW_MESSAGE_BOX_BASED_ON_DATA: 'SHOW_MESSAGE_BOX_BASED_ON_DATA',
    SHOW_MESSAGE_BOX: 'SHOW_MESSAGE_BOX',
    MESSAGE_BOX_INPUT_VALUE_CHANGED: 'MESSAGE_BOX_INPUT_VALUE_CHANGED',
    CHANGE_PATIENT_SEARCH_VALUE: 'CHANGE_PATIENT_SEARCH_VALUE',
    CHANGE_PATIENT_DOB_VALUE: 'CHANGE_PATIENT_DOB_VALUE',
    SET_PATIENTS_LIST: 'SET_PATIENTS_LIST',
    SELECT_PATIENT: 'SELECT_PATIENT',
    SET_CURRENT_STEP: 'SET_CURRENT_STEP',
    VALIDATE_ENTERED_DOB: 'VALIDATE_ENTERED_DOB'
};

export const MessageBoxTypes = {
    CREATE_NEW_RECORD: 'CREATE_NEW_RECORD',
    RELOAD: 'RELOAD'
};